import {
    type BreakingNews,
    type NewBreakingNews,
    type NewUnityBreakingNews,
    type UnityBreakingNews,
} from '@@api/services/breakingnews/schemas';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';

import { deserializeVariants, serializeVariants } from '../../utils/transformers';

export const deserializeBreakingnews = (entity: UnityBreakingNews): BreakingNews => {
    const variants = deserializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: deserializeState(variant.lead),
        body: deserializeState(variant.body),
        allowAutomaticTeaserUpdate: true,
    }));

    return {
        ...entity,
        variants,
    };
};

export const serializeBreakingnews = (entity: BreakingNews): UnityBreakingNews => {
    const variants = serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
        body: serializeState(variant.body),
    }));

    return {
        ...entity,
        variants,
    };
};
export const serializeNewBreakingnews = (entity: NewBreakingNews): NewUnityBreakingNews => {
    const variants = serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
        body: serializeState(variant.body),
    }));

    return {
        ...entity,
        variants,
    };
};
